import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=2bd8b8d2&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=2bd8b8d2&prod&lang=scss&scoped=true"
import style1 from "./NavigationBar.vue?vue&type=style&index=1&id=2bd8b8d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8b8d2",
  null
  
)

export default component.exports